import { EventEntity } from '../schema/EventEntity';
import { EventsCache } from '../schema/EventsCache';
import { ObservableMap } from 'mobx';

export function createEventsCache<T extends EventEntity>(): EventsCache<T> {
    return {
        events: [],
        locksInfo: new ObservableMap(),
    };
}
